import { createSlice } from '@reduxjs/toolkit';
import { IDepartmentState } from '../types';
import { getDepartment } from '../../service/api';

const initialState: IDepartmentState = {
  page: null,
  pending: false,
  error: null,
};

export const departmentSlice = createSlice({
  name: 'departmentSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDepartment.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getDepartment.fulfilled, (state, action) => {
        state.page = action.payload;
        state.pending = false;
      })
      .addCase(getDepartment.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export default departmentSlice.reducer;
